import TermsAndPrivacyNotice from '@/components/forms/TermsAndPrivacyNotice';
import {
  HubspotCompanySizeDropdownOptions,
  HubspotFieldLabels,
  HubspotFieldNames
} from '@/constants/hubspot';
import { isWorkEmail } from '@/lib/validation';
import { FC } from 'react';
import { ButtonElement } from '../Button';

import { getFormikFieldErrorFunction } from '@/lib/formik';
import { FormikProps } from 'formik';
import { Checkbox } from '../Checkbox';
import { InputField } from '../InputField';
import { SelectField } from '../SelectField';
import { GdprOptInState } from './RequestDemo.hooks';

export type RequestDemoFormStepOneFields = {
  [HubspotFieldNames.CompanySize]: string;
  [HubspotFieldNames.Email]: string;
  [HubspotFieldNames.MarketingEmailOptOut]: boolean;
}

export type DemoFormStepOneProps = {
  formik: FormikProps<RequestDemoFormStepOneFields>;
  gdprOptIn: GdprOptInState | null;
}

const DemoFormStepOne: FC<DemoFormStepOneProps> = ({ formik, gdprOptIn }) => {
  const isNotWorkEmail = !isWorkEmail(formik.values[HubspotFieldNames.Email]);
  const getFieldError = getFormikFieldErrorFunction(formik);
  const emailError = getFieldError(HubspotFieldNames.Email);
  const companySizeError = getFieldError(HubspotFieldNames.CompanySize);
  const isSubmitDisabled = formik.isValidating || formik.isSubmitting || !!emailError || !!companySizeError;

  return (
    <form id="demo-form-step-one" className="flex flex-col" onSubmit={formik.handleSubmit} noValidate>
      <fieldset className="flex flex-col gap-lg py-xl">
        <InputField
          type="email"
          name={HubspotFieldNames.Email}
          label={HubspotFieldLabels.Email}
          placeholder="you@company.com"
          value={formik.values[HubspotFieldNames.Email]}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          warningMessage={isNotWorkEmail ? "Please enter your work email." : undefined}
          errorMessage={emailError}
        />

        <SelectField
          name={HubspotFieldNames.CompanySize}
          label={HubspotFieldLabels.CompanySize}
          placeholder="Select one"
          options={Object.entries(HubspotCompanySizeDropdownOptions).map(([label, value]) => ({ label, value }))}
          value={formik.values[HubspotFieldNames.CompanySize]}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          errorMessage={companySizeError}
        />


        {gdprOptIn && (
          <Checkbox
            name={HubspotFieldNames.MarketingEmailOptOut}
            checked={gdprOptIn.checked}
            className="my-auto [&_input]:border-gray-600"
            onChange={(e) => gdprOptIn.onToggle(e.target.checked)}
            label="Opt into emails with the latest news, offers, promotions, and resources from Front."
          />
        )}
      </fieldset>
      <ButtonElement
        variant="primary"
        buttonType="filled"
        className="mb-s"
        disabled={isSubmitDisabled}
        text={formik.isValidating || formik.isSubmitting ? 'Submitting' : 'Continue'} />
      <TermsAndPrivacyNotice />

    </form>
  );
};

export default DemoFormStepOne;
